package ca.northroot.app.utils

import kotlinx.datetime.*

actual object DateTimeUtils {
    actual fun toLong(timestamp: Any?): Long? {
        if (timestamp == null) return null
        
        // 1. Direct Numeric Types
        if (timestamp is Long) return timestamp
        if (timestamp is Double) return timestamp.toLong()
        if (timestamp is Int) return timestamp.toLong()

        // 2. Browser/Firestore Dynamic Objects
        return try {
            val d: dynamic = timestamp
            
            // Check for standard JS Date properties
            if (d.getTime != undefined) {
                return (d.getTime() as Double).toLong()
            }
            
            // Check for Firestore Timestamp properties (seconds/nanoseconds)
            if (d.seconds != undefined && d.seconds != null) {
                return (d.seconds as Double).toLong() * 1000
            }
            
            // Check for Firestore-like internal properties (sometimes used in proxies)
            if (d["seconds"] != undefined) {
                return (d["seconds"] as Double).toLong() * 1000
            }

            // Native JS Date via toDate() helper (often present on Firestore objects)
            if (d.toDate != undefined) {
                return (d.toDate().getTime() as Double).toLong()
            }
            
            // Numeric strings or ISO strings
            if (timestamp is String) {
                timestamp.toLongOrNull() ?: try {
                    Instant.parse(timestamp).toEpochMilliseconds()
                } catch (e: Exception) {
                    null
                }
            } else null
        } catch (e: Exception) {
            null
        }
    }

    actual fun formatTime(timestamp: Any?): String {
        val timeLong = toLong(timestamp) ?: return "TBD"
        return try {
            val instant = Instant.fromEpochMilliseconds(timeLong)
            val dateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
            val hourRaw = dateTime.hour
            val ampm = if (hourRaw < 12) "AM" else "PM"
            val hour = when {
                hourRaw == 0 -> 12
                hourRaw > 12 -> hourRaw - 12
                else -> hourRaw
            }
            val minute = dateTime.minute.toString().padStart(2, '0')
            "$hour:$minute $ampm"
        } catch (e: Exception) {
            "Time Err"
        }
    }

    actual fun formatDate(timestamp: Any?): String {
        val timeLong = toLong(timestamp) ?: return "TBD"
        return try {
            val instant = Instant.fromEpochMilliseconds(timeLong)
            val dateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
            "${dateTime.month.name.take(3)} ${dateTime.dayOfMonth}"
        } catch (e: Exception) {
            "Date Err"
        }
    }

    actual fun formatFullDate(timestamp: Any?): String {
        val timeLong = toLong(timestamp) ?: return "TBD"
        return try {
            val instant = Instant.fromEpochMilliseconds(timeLong)
            val dateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
            val dayName = dateTime.dayOfWeek.name.lowercase().replaceFirstChar { it.uppercase() }
            val monthName = dateTime.month.name.lowercase().replaceFirstChar { it.uppercase() }
            "$dayName, $monthName ${dateTime.dayOfMonth}"
        } catch (e: Exception) {
            "Date Err"
        }
    }
}
